var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnWatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0,
    width: 30,
    height: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg_icn_primary",
    d: "M25.755,3.063H4.011A2.921,2.921,0,0,0,1.094,5.981v13.8A2.921,2.921,0,0,0,4.011,22.7h7.043L10.205,26.94H7.458a0.531,0.531,0,0,0,0,1.061h14.85a0.531,0.531,0,0,0,0-1.061H19.561L18.712,22.7h7.043a2.921,2.921,0,0,0,2.917-2.918V5.981A2.921,2.921,0,0,0,25.755,3.063ZM11.287,26.94L12.136,22.7H17.63l0.849,4.245H11.287Zm16.324-7.163a1.859,1.859,0,0,1-1.856,1.857H4.011a1.859,1.859,0,0,1-1.856-1.857V18.451H27.612v1.327h0Zm0-2.388H2.154V16.328H5.337a0.531,0.531,0,0,0,0-1.061H2.154V5.981A1.859,1.859,0,0,1,4.011,4.124H25.755a1.859,1.859,0,0,1,1.856,1.857V17.389h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg_icn_secondary",
    d: "M10.5,8A3.5,3.5,0,1,1,7,11.5,3.5,3.5,0,0,1,10.5,8Zm12,4A1.5,1.5,0,1,1,21,13.5,1.5,1.5,0,0,1,22.5,12Zm-3-6A2.5,2.5,0,1,1,17,8.5,2.5,2.5,0,0,1,19.5,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWatch);
export default __webpack_public_path__ + "static/media/icn_watch.18d1bf8e.svg";
export { ForwardRef as ReactComponent };